import React, { useRef } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import "./index.css";
import {
  TransformWrapper,
  TransformComponent,
  useControls,
} from "react-zoom-pan-pinch";
import ZoomIn from "@mui/icons-material/ZoomIn";
import ZoomOut from "@mui/icons-material/ZoomOut";
import Rotate90DegreesCwIcon from "@mui/icons-material/Rotate90DegreesCw";
import Rotate90DegreesCcwIcon from "@mui/icons-material/Rotate90DegreesCcw";

interface Props {
  imageUrl: string;
}

interface ControlProps {
  handleRotation: (degree: 90 | -90) => void;
}

const Controls: React.FC<ControlProps> = ({ handleRotation }) => {
  const { zoomIn, zoomOut } = useControls();
  return (
    <Box className="image-viewer-control">
      <Tooltip title={`Zoom In`} aria-label="zoom-in-tooltip">
        <IconButton
          size="small"
          aria-label="zoom-in-button"
          component="span"
          onClick={() => zoomIn()}
          style={{ marginBottom: "8px" }}
        >
          <ZoomIn style={{ fontSize: 40, color: "rgb(66, 139, 202)" }} />
        </IconButton>
      </Tooltip>
      <Tooltip title={`Zoom Out`} aria-label="zoom-out-tooltip">
        <IconButton
          size="small"
          aria-label="zoom-out-button"
          component="span"
          onClick={() => zoomOut()}
          style={{ marginBottom: "8px" }}
        >
          <ZoomOut style={{ fontSize: 40, color: "rgb(66, 139, 202)" }} />
        </IconButton>
      </Tooltip>
      <Tooltip title={`Rotate -90°`} aria-label="Rotate--90°-tooltip">
        <IconButton
          size="small"
          aria-label="rotate-90-button"
          component="span"
          onClick={() => {
            handleRotation(-90);
          }}
          style={{ marginBottom: "8px" }}
        >
          <Rotate90DegreesCcwIcon
            style={{ fontSize: 40, color: "rgb(66, 139, 202)" }}
          />
        </IconButton>
      </Tooltip>
      <Tooltip title={`Rotate 90°`} aria-label="Rotate-90°-tooltip">
        <IconButton
          size="small"
          aria-label="rotate-90-button"
          component="span"
          onClick={() => {
            handleRotation(90);
          }}
          style={{ marginBottom: "8px" }}
        >
          <Rotate90DegreesCwIcon
            style={{ fontSize: 40, color: "rgb(66, 139, 202)" }}
          />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

const ImageViewer: React.FC<Props> = ({ imageUrl }) => {
  const canvasRef = useRef<HTMLImageElement>(null);
  const [rotation, setRotation] = React.useState(0);

  const handleRotation = (degree: 90 | -90) => {
    setRotation(rotation + degree);
    if (canvasRef.current) {
      canvasRef.current.style.transform = `rotate(${rotation + degree}deg)`;
    }
  };

  return (
    <div className="image-viewer-container">
      <TransformWrapper wheel={{ step: 20, smoothStep: 0.05 }}>
        <Controls handleRotation={handleRotation} />
        <div className="image-viewer-image">
        <TransformComponent>
           <img
              ref={canvasRef}
              src={imageUrl}
              alt="big specimen"
              className="image"
            />
        </TransformComponent>
        </div>
      </TransformWrapper>
    </div>
  );
};

export default ImageViewer;
